import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { listSearch } from "../../../shared/utils/pagination-search";
import { RouteError } from "../../../shared/components/RouteError";

const requestsSearchSchema = listSearch.extend({
  documentTypeId: z.string().optional(),
  locationId: z.string().optional(),
  status: z.enum(["active", "finished"]).optional(),
});

/**
 * @purpose Find requests across all types filtered by type, location or status
 * @primary Filtered requests table
 * @persona paola-admin-belora, sports-manager-ikos
 */
export const Route = createFileRoute("/app/c/$customerSlug/requests/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  validateSearch: requestsSearchSchema,
});
